import { StyledProps } from '@front10';
import React from 'react';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
import { TextProps } from '../../../elements/Text/Text';
import Title from './Title';

interface Props {
  showTitle?: boolean;
  showDirections?: boolean;
  titleStyles?: React.ComponentPropsWithoutRef<typeof Title>;
  directionsStyles?: TextProps;
  directions?: string;
}

function Directions({
  showTitle = true,
  showDirections = true,
  titleStyles,
  directionsStyles,
  directions = '',
  style = {
    textDecoration: 'underline',
  },
  ...props
}: StyledProps<Props>) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      textColor="primary"
      marginTop="3"
      style={style}
      {...props}
    >
      {showTitle && <Title {...titleStyles} />}
      {showDirections && <Text {...directionsStyles}>{directions}</Text>}
    </Box>
  );
}

Directions.componentName = 'Directions';

export default Directions;
